import Dropdown from './Dropdown'

Dropdown.install = function install (Vue) {
  Vue.component(Dropdown.name, Dropdown)
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/reusable/dropdown/index.js